/** Query parameter carrying the view a financial item was opened from. */
export const RETURN_TO_PARAM = 'returnTo';

/**
 * Where saving a financial item returns to: the view the adviser came from when one was
 * carried through, otherwise the owning client's own Financials tab. An item added from a
 * family screen hangs off one member but was added to the household, so it returns to the
 * family's Financials rather than that member's.
 */
export function financialsReturnPath(clientId: string, returnTo?: string | null): string {
  // Only in-app paths. The value reaches us through the query string, where a protocol-relative
  // one would turn an internal navigation into an off-site redirect.
  if (returnTo?.startsWith('/') && !returnTo.startsWith('//')) {
    return returnTo;
  }
  return `/client/${clientId}/financial-data`;
}
